export default __webpack_public_path__ + "media/eacefd31acc1e10c183af563fa05f1681468666972de1adc6e83ecdb9806720d.svg";